import { render, staticRenderFns } from "./ObjectSearch.vue?vue&type=template&id=0405c121&scoped=true&"
import script from "./ObjectSearch.vue?vue&type=script&lang=js&"
export * from "./ObjectSearch.vue?vue&type=script&lang=js&"
import style0 from "./ObjectSearch.vue?vue&type=style&index=0&id=0405c121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405c121",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VContainer,VDialog,VIcon,VRow,VTextField})
